/**
 * Product info column stickiness.
 *
 * The column pins below the header so the product's title block stays visible.
 * That works while the panel is shorter than the space it has: open a couple of
 * accordions and it is not, and a pinned panel taller than the viewport strands
 * its own bottom off-screen where no amount of scrolling reaches it.
 *
 * So the offset is chosen from the panel's height. Short enough to fit, and it
 * pins below the header as expected. Taller than that, and the offset goes
 * negative by the overflow, which lets the panel scroll up until its bottom is
 * in view and only then pins - the reader can still reach the end of it.
 *
 * Recomputed from a ResizeObserver on the panel itself, so it covers accordions
 * opening, variant swaps re-rendering the section, and font loading, without
 * needing to know about any of them.
 */
(function () {
  var SELECTOR = '.product__info-container--sticky';
  var DESKTOP = '(min-width: 990px)';
  var GAP = 20;

  function headerOffset() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-bottom-position');
    var value = parseFloat(raw);
    return isNaN(value) ? 60 : value;
  }

  function update(panel) {
    if (!panel) return;

    if (!window.matchMedia(DESKTOP).matches) {
      panel.style.top = '';
      return;
    }

    var offset = headerOffset() + GAP;
    var available = window.innerHeight - offset;
    var height = panel.offsetHeight;

    if (height <= available) {
      panel.style.top = offset + 'px';
    } else {
      panel.style.top = (window.innerHeight - height - GAP) + 'px';
    }
  }

  function watch(panel) {
    update(panel);

    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(function () {
        update(panel);
      }).observe(panel);
    }

    window.addEventListener('resize', function () {
      update(panel);
    });
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The section re-renders on variant change, replacing the panel.
  document.addEventListener('product-info:loaded', init);
})();
